/**
 * BrandRegisterPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  Descriptions,
  ModalLayout,
} from 'components';
import { Select, Table, Input, Button, Tag, Spin, Divider } from 'antd';
import { stringToMoneyFormat } from 'utils';
import moment from 'moment';
import {
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  APPLICATION_STATUS,
} from 'constants/ProductConstants';
import { APPLICATION_STATUS as SHOP_APPLICATION_STATUS } from 'constants/ShopInfomationConstants';
import { EditOutlined, DownOutlined } from '@ant-design/icons';

/**----------------------------------------
 * [Component] 입점업체 상세: 프레젠터
 * ----------------------------------------
 */
const BrandRegisterPresenter = ({
  loading,
  shopId,
  shopInfomation,
  productList,
  onChangeApplicationStatus,
  onChangeProduct,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [feedbackText, setFeedbackText] = useState('');
  const [productFeedback, setProductFeedback] = useState('');
  const [productFeedbackModal, setProductFeedbackModal] = useState(null);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  console.log('shopInfomation: ', shopInfomation);
  console.log('productList: ', productList);

  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Title size={5}>업체정보</Title>
        {shopInfomation && (
          <Descriptions
            className="boxShadow"
            size="small"
            // layout="vertical"
            column={3}
            bordered
            contentStyle={{ textAlign: 'right' }}
            items={[
              // Line 1
              {
                key: 'shop_information_name',
                label: '업체명',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                // contentStyle: { textAlign: 'center' },
                children: <p>{shopInfomation.shop_information_name}</p>,
              },
              {
                key: 'shop_information_postcode',
                label: '업체코드',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: <p>{shopInfomation.shop_information_postcode}</p>,
              },
              {
                key: 'updated_at',
                label: '등록일',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: (
                  <p>
                    {moment(shopInfomation.updated_at * 1000).format(
                      'YYYY-MM-DD(HH:mm:ss)'
                    )}
                  </p>
                ),
              },
              // Line 3
              {
                key: 'business_hour',
                label: '운영시간',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: (
                  <p>{shopInfomation.mall_information.business_hour}</p>
                ),
              },
              {
                key: 'store_num',
                label: '연락처',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: <p>{shopInfomation.mall_information.store_num}</p>,
              },
              {
                key: 'store_status',
                label: '영업',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: <p>{shopInfomation.store_status}</p>,
              },
              // Line 2
              {
                key: 'business_num',
                label: '사업자번호',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: <p>{shopInfomation.mall_information.business_num}</p>,
              },
              {
                key: 'shop_information_address',
                label: '주소',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                span: 2,
                children: (
                  <p>
                    [{shopInfomation.shop_information_postcode}]{' '}
                    {shopInfomation.shop_information_address}(
                    {shopInfomation.shop_information_address_detail})
                  </p>
                ),
              },

              // Line 4
              {
                key: 'business_hour',
                label: '심사여부',
                labelStyle: { width: '12%' },
                contentStyle: { width: '18%' },
                children: (
                  <p>
                    <Select
                      defaultValue={shopInfomation.application_status}
                      style={{
                        width: 145,
                      }}
                      onChange={(v) =>
                        onChangeApplicationStatus('application_status', v)
                      }
                      options={Object.keys(SHOP_APPLICATION_STATUS).map(
                        (value) => ({
                          label: SHOP_APPLICATION_STATUS[value].title,
                          value,
                        })
                      )}
                    />
                  </p>
                ),
              },
              {
                key: 'store_num',
                label: '피드백',
                span: 2,
                labelStyle: { width: '12%', height: 105 },
                contentStyle: { height: 155 },
                children: (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ flex: 5 }}>
                      <Input.TextArea
                        defaultValue={
                          shopInfomation?.edit_information?.feedbackText[0]
                        }
                        // value={feedbackText}
                        placeholder="내용을 입력해주세요"
                        autoSize={{
                          minRows: 3,
                          maxRows: 3,
                        }}
                        onChange={(e) => setFeedbackText(e.target.value)}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Button
                        style={{
                          width: 80,
                          height: '100%',
                        }}
                        onClick={() => {
                          onChangeApplicationStatus('edit_information', {
                            ...shopInfomation?.edit_information,
                            feedbackText: [
                              feedbackText,
                              ...shopInfomation?.edit_information.feedbackText,
                            ],
                          });
                        }}
                      >
                        저장
                      </Button>
                    </div>
                  </div>
                ),
              },
            ]} //
          />
        )}

        <br />
        <Title size={5}>등록상품 ({productList.length})</Title>
        <div style={{ overflowX: 'auto' }}>
          <Table
            bordered
            size="small"
            style={{ width: 1500 }}
            dataSource={productList ?? []}
            columns={[
              {
                title: '상품코드',
                dataIndex: 'product_code',
                width: 150,
                align: 'center',
              },
              {
                title: '상품명',
                dataIndex: 'product_name',
                // width: 200,
                align: 'center',
                render: (v, record) => (
                  <a
                    href={`/#/products/${record.product_code}`}
                    style={{ textDecoration: 'underline' }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        e.currentTarget.href,
                        '_blank',
                        'width=860, height=620'
                      );
                    }}
                  >
                    {v}
                  </a>
                ),
              },

              {
                title: '상품유형',
                dataIndex: 'type',
                width: 120,
                align: 'center',
                render: (v) => PRODUCT_TYPE[v].title,
              },
              {
                title: '금액',
                dataIndex: 'price',
                width: 110,
                align: 'center',
                render: (v) => (
                  <p style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</p>
                ),
              },
              {
                title: '옵션',
                dataIndex: 'product_option',
                width: 100,
                align: 'center',
                render: (v) => `${v.length}개`,
              },

              {
                title: '노출여부',
                dataIndex: 'is_show',
                width: 100,
                align: 'center',
                render: (v) => (v === 'Y' ? '노출' : '미노출'),
              },
              {
                title: '상태',
                dataIndex: 'product_status',
                width: 100,
                align: 'center',
                render: (v) => {
                  const { color, title } = PRODUCT_STATUS[v];
                  return <Tag color={color}>{title}</Tag>;
                },
              },
              {
                title: '등록신청',
                dataIndex: 'application_status',
                width: 100,
                align: 'center',
                render: (v) => {
                  const { color, title } = APPLICATION_STATUS[v];
                  return <Tag color={color}>{title}</Tag>;
                },
              },
              {
                title: '심사',
                width: 130,
                align: 'center',
                render: (v) => {
                  console.log('v: ', v);

                  return (
                    <>
                      <Select
                        defaultValue={v.application_status}
                        style={{
                          width: '100%',
                        }}
                        options={Object.keys(APPLICATION_STATUS).map(
                          (value) => ({
                            label: APPLICATION_STATUS[value].title,
                            value,
                          })
                        )}
                        onChange={(value) =>
                          onChangeProduct(
                            v.product_id,
                            'application_status',
                            value
                          )
                        }
                      />
                    </>
                  );
                },
              },
              {
                title: '피드백',
                width: 140,
                align: 'center',
                render: (v) => (
                  <>
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={() => setProductFeedbackModal(v)}
                    >
                      <EditOutlined /> 등록
                    </Button>
                  </>
                ),
              },
            ]}
          />
        </div>
        <Row>
          <Col x={24}>
            <Content maxWidth={'100%'} borderRadius={4} padding={20}>
              {/* <Empty
              style={{
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              description={
                <>
                  <Title align={'center'}>개발중입니다.</Title>
                </>
              }
            ></Empty> */}
              {/* {JSON.stringify(productList)} */}
            </Content>
          </Col>
        </Row>
      </Content>

      {/* ===== 피드백 등록 모달 ===== */}
      <ModalLayout
        width={400}
        maxWidth={'calc(100% - 250px)'}
        isOpen={productFeedbackModal !== null}
        open={productFeedbackModal !== null}
        title="상품 피드백 등록"
        closable={true}
        onCancel={() => setProductFeedbackModal(null)}
        footer={
          <>
            <Button
              type="primary"
              onClick={() => {
                onChangeProduct(
                  productFeedbackModal.product_id,
                  'apply_feedback',
                  productFeedback
                );
                setProductFeedbackModal(null);
                setProductFeedback('');
              }}
            >
              등록완료
            </Button>
          </>
        }
      >
        <Divider style={{ margin: '14px 0' }} />
        {productFeedbackModal && (
          <div>
            <p>이전 피드백: {productFeedbackModal.apply_feedback}</p>
            <Input
              placeholder="피드백을 입력해주세요"
              value={productFeedback}
              onChange={(e) => setProductFeedback(e.target.value)}
            />
          </div>
        )}
      </ModalLayout>
    </Spin>
  );
};

export default BrandRegisterPresenter;
